import React from "react";
import Layout from "../../components/ui/Layout";
import StoreLayout from "./StoreLayout";

function Store() {
  return(
    <section className="w-full h-screen bg-black bg-opacity-50 z-10">
      <Layout>
        <StoreLayout />
      </Layout>
    </section>
  );
}

export default(Store);